import React, { useLayoutEffect } from 'react';
import styles from './QuizV2.module.scss'

import OrbitElementsSimulator from "../OrbitElementsSimulator/OrbitElementsSimulator";
import Button, {ButtonsHolder} from "../../../partials/Button";

import ContentBox from "../common/ContentBox/ContentBox";
import QuestionGroup from "./QuestionGroup/QuestionGroup";
import Option from './QuestionGroup/Option/Option'
import FeedBack from "./FeedBack/FeedBack";
import { OrbitsContext } from "../Context/OrbitsContext";
import Icon from '../../../partials/Icons';
import Scroll from './../../../partials/Scroll/Scroll';
import { SimpleModal } from './../../../partials/Modal'
import FeedbackBlock from './../../../partials/FeedbackBlock/index'

function QuizV2({ orbit, dispatchers, onGoBack, onContinue }) {
    const [buttonsState, setButtonsState] = React.useState({
        submit: { show: true },
        retry: { show: false },
        orbitsMenu: { show: false }
    })
    const [view, setView] = React.useState('exploreorbit')
    const [hideWrong, setHideWrong] = React.useState(false)
    const [hideUnselected, setHideUnselected] = React.useState(false)

    const [showFeedback, setShowFeedback] = React.useState(false)
    const [isCorrect, setIsCorrect] = React.useState(false)
    const quiz = orbit.quiz[0] || orbit.quiz

    if (!quiz) {
        throw new Error('could not load quiz json')
    }

    const [options, setOptions] = React.useState(() => quiz.options.map(o => {
        return {
            ...o,
            selected: false
        }
    }))

    const orbitsState = React.useContext(OrbitsContext)

    const getValues = aspect => {

        try {
            const orbitGroundData = orbitsState.groundData[orbit.header.toLowerCase()]
            const aspectValues = [...new Set(orbitGroundData.map(d => d[aspect]))]
            return aspectValues.sort(function (a, b) {
                return a - b
            })

        } catch (e) {
            console.error("Invalid Orbit groundData for :" + orbit.header.toLowerCase())
            console.log(e.message)
        }
        return [];
    }

    const smaValues = getValues('sma')
    const incValues = getValues('inc')
    const eccValues = getValues('ecc')

    useLayoutEffect(() => {
        dispatchers.setCurrentBackground('starfield')
        orbitsState.setCurrentGoBackCallback(() => onGoBack)
    }, [])

    const handleOnSubmit = () => {

        let isCorrect = true;

        for (let i = 0; i < options.length; i++) {
            if ((options[i].selected === true && options[i].correct !== true) ||
                (options[i].selected === false && options[i].correct === true)) {
                isCorrect = false;
                break;
            }
        }

        if (isCorrect === true) {
            setIsCorrect(true)
            setHideWrong(true)
            setShowFeedback(true)
            setButtonsState({
                ...buttonsState,
                orbitsMenu: { ...buttonsState.orbitsMenu, show: true },
                retry: { ...buttonsState.retry, show: false },
                submit: { ...buttonsState.submit, show: false }
            })
            return
        }

        setIsCorrect(false)
        setHideUnselected(true)
        setShowFeedback(true)
        setButtonsState({
            ...buttonsState,
            retry: { ...buttonsState.retry, show: true },
            submit: { ...buttonsState.submit, show: false },
            orbitsMenu: { ...buttonsState.retry, show: !quiz.gated }

        })
    }

    const handleSelectedOption = (selected) => {
        const selectedOption = options.find(o => selected.text === o.text)
        if (selectedOption) {
            setOptions(options.map(o => {
                if (o.text === selectedOption.text) {
                    return {
                        ...o,
                        selected: !o.selected
                    }
                }
                return o;
            }))
        }
    }

    const handleRetry = () => {
        // Set all answers as unselected
        setOptions(options.map(o => {
            return { ...o, selected: false }
        }))
        // Enable submit button, hide Retry.
        setButtonsState({
            ...buttonsState,
            submit: { show: true },
            retry: { show: false },
            orbitsMenu: { show: false }
        })
        setShowFeedback(false)
        setHideUnselected(false);
        setHideWrong(false)
    }

    const handleOnOrbitsMenu = () => {
        onContinue(isCorrect, orbit)
    }

    return <div className={styles.QuizV2}>

        <div className="back-btn-container" style={{ zIndex: 10 }} >
            <Button variant={'back'} text={'BACK'} onClick={() => {
                onGoBack();
            }} />
        </div>

        <div className={styles.Scenario}>
            <ContentBox title={'Scenario'} variant="blueish" htmlContent={quiz.scenario} >

            </ContentBox>
        </div>

        <div className={styles.Simulator}>
            <OrbitElementsSimulator
                doAltitude={true}
                perigee={orbit?.orbitData?.perigee|| orbit?.orbitData?.sma }
                orbit={orbit}
                sma={orbit?.orbitData?.sma || 0}
                inc={orbit?.orbitData?.inc || 0}
                ecc={orbit?.orbitData?.ecc || 0}
                SMAValues={smaValues}
                InclinationValues={incValues}
                EccentricityValues={eccValues}
                showSliders={false}
                showGroundData={false}
            />
        </div>

        <div
            className={styles.TabbedContent}
            style={{
                marginTop: "20px"
            }}
        >
            <ContentBox title={quiz.question} variant={''} htmlContent={quiz.instructions} fitContent></ContentBox>
            <QuestionGroup>
                {options &&
                    options.map(q => {
                        if (hideWrong && q.correct === false) {
                            return <></>
                        }
                        if (hideUnselected && q.selected === false) {
                            return <></>
                        }
                        return <div style={{ display: `flex`, justifyContent: `space-evenly` }}>
                            <Option
                                selected={q.selected}
                                key={q.text}
                                option={q}
                                onSelected={handleSelectedOption}
                            >{q.text}</Option>
                            {showFeedback && q.selected ? <div style={{ width: `15%`, display: `flex`, justifyContent: `center` }}><Icon name={isCorrect ? `check` : `incorrect`} /></div> : null}
                        </div>
                    })}
            </QuestionGroup>


            {showFeedback &&
                <SimpleModal size="small" scroll={false} show={true} className='simple-modal'>
                    <FeedbackBlock variant="fill" status={isCorrect ? 'success' : 'failed'} caption={isCorrect ? 'Correct' : 'Incorrect'}>
                        <Scroll>
                            <div className='feedback-text' style={{ color: `white` }} dangerouslySetInnerHTML={{ __html: isCorrect ? quiz.delayedFeedback.correct.body : quiz.delayedFeedback.incorrect.body }}></div>
                        </Scroll>
                        <ButtonsHolder orientation={"center"}>
                            {isCorrect &&
                                <Button text="Next" onClick={handleOnOrbitsMenu} />
                            }
                            {!isCorrect &&
                                <Button text="Retry" onClick={handleRetry} />
                            }
                            {!isCorrect && buttonsState.orbitsMenu.show && <Button
                                className={styles.SubmitButton} onClick={handleOnOrbitsMenu}
                                text={quiz.delayedFeedback.correct.button}
                            />}
                        </ButtonsHolder>
                    </FeedbackBlock>

                </SimpleModal>
            }

            <div className={styles.ActionGroup}>
                {buttonsState.submit.show && <Button
                    className={styles.SubmitButton} onClick={handleOnSubmit}
                    text={'SUBMIT'}
                />}
                {/*{buttonsState.retry.show && <Button*/}
                {/*    className={styles.SubmitButton} onClick={handleRetry}*/}
                {/*    text={quiz.delayedFeedback.incorrect.button}*/}
                {/*/>}*/}
                {/*{buttonsState.orbitsMenu.show && <Button*/}
                {/*    className={styles.SubmitButton} onClick={handleOnOrbitsMenu}*/}
                {/*    text={quiz.delayedFeedback.correct.button}*/}
                {/*/>}*/}
            </div>

        </div>
    </div>
}

export default QuizV2;

